module.exports = __webpack_public_path__ + "static/media/meter-conservative.e4a97af8.svg";